// let headerLogin = document.getElementById("login");
// let headerFav = document.getElementById("fav");
// let headerContact = document.getElementById("contact");

let trigger = document.getElementById("trigger");
let headerSp = document.getElementById("navSp");

let headerLogo = document.querySelector(".canvas-header__logo");
let headerSearch = document.querySelector(".canvas-header__search");
let buttonWrapper = document.querySelector(".canvas-header__button-wrapper");
let headerBottom = document.querySelector(".canvas-header-bottom");

let headertopSP = document.querySelector(
  ".canvas-header-sp .canvas-header-top"
);
let headerLogoSP = document.querySelector(
  ".canvas-header-sp .canvas-header-top .canvas-header__logo"
);
let headerSearchSP = document.querySelector(
  ".canvas-header-sp .canvas-header-top .canvas-header__search"
);
let buttonWrapperSP = document.querySelector(
  ".canvas-header-sp .canvas-header-top .canvas-header__button-wrapper"
);
let headerBottomSP = document.querySelector(
  ".canvas-header-sp .canvas-header-bottom"
);

trigger.addEventListener("click", () => {
  headerSp.classList.toggle("active");
  trigger.classList.toggle("canvas-header__trigger--open");
  headertopSP.classList.toggle("header__sp");
  headerLogoSP.classList.toggle("header__sp");
  headerSearchSP.classList.toggle("header__sp");
  buttonWrapperSP.classList.toggle("header__sp");
  headerBottomSP.classList.toggle("header__sp");
});
//
let header = document.querySelector(".canvas-header");
let mainPadding = document.getElementById("MainContent");
let headerHeight = header.offsetTop;

window.onscroll = function () {
  let windowTop = window.scrollY;
  if (windowTop >= headerHeight) {
    header.classList.add("drop");
    mainPadding.classList.add("mainDrop");
  } else {
    header.classList.remove("drop");
    mainPadding.classList.remove("mainDrop");
  }
};
